import React, { useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Button,
  Fade,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArticleIcon from '@mui/icons-material/Article';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fetchFeaturedBlogsThunk } from '../../store/thunks/blogsThunks';
import BlogCard from '../blogs/BlogCard';

const BlogSection: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { featuredBlogs } = useAppSelector((state) => state.blogs);

  useEffect(() => {
    dispatch(fetchFeaturedBlogsThunk(6));
  }, [dispatch]);

  if (featuredBlogs.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        background: 'linear-gradient(180deg, rgba(20, 15, 35, 1) 0%, rgba(0, 0, 0, 1) 100%)',
        py: { xs: 8, md: 12 },
        position: 'relative',
      }}
    >
      <Container maxWidth="lg">
      <Fade in timeout={1200}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Box
            sx={{
              display: 'inline-flex',
              p: 2,
              borderRadius: 3,
              background: 'linear-gradient(135deg, rgba(236, 72, 153, 0.2) 0%, rgba(139, 92, 246, 0.2) 100%)',
              mb: 3,
            }}
          >
            <ArticleIcon sx={{ fontSize: 48, color: 'secondary.main' }} />
          </Box>
          <Typography
            variant="h3"
            component="h2"
            sx={{ mb: 2, fontWeight: 700 }}
          >
            Latest Blog Posts
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '600px', mx: 'auto' }}>
            Discover tutorials, tips, and industry insights to enhance your learning
          </Typography>
        </Box>
      </Fade>
      <Grid container spacing={4}>
        {featuredBlogs.map((blog, index) => (
          <Grid item xs={12} sm={6} md={4} key={blog.id}>
            <BlogCard blog={blog} index={index} />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ textAlign: 'center', mt: 6 }}>
        <Button
          variant="outlined"
          size="large"
          endIcon={<ArrowForwardIcon />}
          onClick={() => navigate('/blog')}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: 3,
            borderColor: 'rgba(236, 72, 153, 0.5)',
            '&:hover': {
              borderColor: '#ec4899',
              background: 'rgba(236, 72, 153, 0.1)',
              transform: 'translateY(-2px)',
            },
          }}
        >
          View All Blog Posts
        </Button>
      </Box>
      </Container>
    </Box>
  );
};

export default BlogSection;

